import {
      GEOGRAPHY_COUNTRY_CHANGE,
      FETCH_GEOGRAPHY,
      GEOGRAPHY_SAVED_AUTHORS,
      GEOGRAPHY_USER_SEARCHES 
    } from '../actions/types';

const initialState = {
        allAuthors: [],
        keyword: "",
        isFetching: false,
        filter: {
            // '1': {value: "France", label: "France", clearableValue: false},
            '1': {value: "United States", label: "United States", clearableValue: false},
            '2': {value: "United Kingdom", label: "United Kingdom", clearableValue: false},
            '3': {value: "Germany", label: "Germany", clearableValue: false},
            '4': {value: "JPN", label: "Japan", clearableValue: false},
        },
        userSearches: [],
        savedAuthors: []
}


export default (state = initialState, action) => {
  
       
    switch (action.type) {
        case GEOGRAPHY_COUNTRY_CHANGE:
        let filter = {
            ...state.filter,
            [action.payload.order]:action.payload.country
        }
        return {
            ...state,
            filter
        }
        break;
        case FETCH_GEOGRAPHY:
            return {
                ...state,
                allAuthors: action.payload.result,
                keyword: action.payload.keyword
            }
            break;
       
        case GEOGRAPHY_USER_SEARCHES:
            return {
                ...state,
                userSearches: action.payload.userSearches
            }
            break;
        case  GEOGRAPHY_SAVED_AUTHORS:
            return {
                ...state,
                savedAuthors: action.payload.savedAuthors
            }
            break;
        default:
            return state;
            break;
    }
}
